import * as AuthenticationActionsCreators from "./Authentication";


export default {
    ...AuthenticationActionsCreators
}
